import { Image, LoadingContainer, LoadingText } from './Loading.styles';
import { LoadingProps } from './Loading.types';

import { getMarketSegment } from '../../utils';
import { MarketSegmentEnum } from '../../types';

import amigoLoadingGif from '../../assets/amigo-loading.gif';
import vodafoneLoadingGif from '../../assets/vodafone-loading.gif';

export default function Loading({ title }: LoadingProps) {
    const loadingGif = getMarketSegment() === MarketSegmentEnum.AMIGO ? amigoLoadingGif : vodafoneLoadingGif;

    return (
        <LoadingContainer>
            <Image src={loadingGif} />
            <LoadingText>{title}</LoadingText>
        </LoadingContainer>
    );
}
